import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'tech-core-quiz-progress-bar',
  standalone: false,
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss'
})
export class ProgressBarComponent implements OnInit {
  @Output() progressComplete = new EventEmitter<void>();

  progress = 0; // Initial progress percentage
  interval: any; // Store interval reference
  readonly duration = 30000; // Total duration (30s)
  readonly intervalTime = 100; // Update every 100ms

  ngOnInit() {
    this.startProgress();
  }

  startProgress() {
    const steps = this.duration / this.intervalTime;
    const increment = 100 / steps;

    this.interval = setInterval(() => {
      if (this.progress < 100) {
        this.progress += increment;
      } else {
        clearInterval(this.interval); // Stop once the bar is full
        console.log("✅ Progress bar fully filled!");

        this.progressComplete.emit();
      }
    }, this.intervalTime);
  }

  stopProgress(): number {
    if (this.interval) {
      clearInterval(this.interval); // Stop the interval

      // Calculate remaining time based on current progress
      const remainingTimeMs = this.duration * (1 - this.progress / 100);
      const remainingTimeSeconds = +(remainingTimeMs / 1000).toFixed(0);

      console.log(`🛑 Progress stopped at ${this.progress.toFixed(2)}%.`);
      console.log(`⏳ Remaining time: ${remainingTimeSeconds} seconds.`);

      return remainingTimeSeconds;
    }
    return 0;
  }

  restartProgress() {
    console.log("🔄 Restarting progress bar...");
    this.progress = 0;
    this.startProgress();
  }
}
